import React from 'react';
import { Link } from 'react-router-dom';

const LeagueErrorPage: React.FC = () => {
    return (
        <div className='mx-4 bg-surface rounded-xl p-4 text-content'>
            <h1 className='text-lg font-semibold'>
                No LeagueID found, Enter your FPL ID and select a league{' '}
                <Link to="/" className='underline text-accent inline-flex min-h-11 items-center px-1'>here</Link>
            </h1>
        </div>
    );
};

export default LeagueErrorPage;